import { AsyncResult, err, ok } from "@jace/api";
import { unwrapOr } from "@zetalabs/core";

export function bytesToKb(bytes: number): string {
	return `${(bytes / 1024).toFixed(2)} KB`;
}

export function tryPromise<
	AsyncFn extends (...args: any[]) => Promise<any>,
	Args extends Parameters<AsyncFn>,
>(func: AsyncFn) {
	return async (...args: Args): AsyncResult<Awaited<ReturnType<AsyncFn>>> => {
		try {
			const result = await func(...args);
			return ok(result);
		} catch (error) {
			return err(unwrapOr(error, new Error("Unknown error")));
		}
	};
}

// TODO: Generators are more idiomatic, but leaving this here
export function iter<T>(input: T[], take: number = 1): Iterator<T[]> {
	let index = 0;

	return {
		next: () => {
			const slice = input.slice(index, index + take);
			index += take;

			if (slice.length > 0) {
				return { value: slice, done: false };
			}

			return { value: undefined, done: true };
		},
	};
}

export function* batchIterate<T>(input: T[], take: number = 1): Generator<T[]> {
	for (let i = 0; i < input.length; i += take) {
		yield input.slice(i, i + take);
	}
}
